import React from "react";
import FormGuide from "./FormGuide";
import { useApi } from "../lib/useApi";

const FormGuidePage = () => {
  const { data: FormGuides = [] } = useApi(`/api/GetFormGuides`, { select: (json) => json.value });

  return (
    <div className="row second">
      <div className="large-12 columns" style={{ paddingLeft: "0.3em" }}>
        <h1>Form Guides - Head 2 Head</h1>
        {FormGuides.map((item) => (
          <FormGuide key={item.name} item={item} />
        ))}
      </div>
    </div>
  );
};

export default FormGuidePage;
